"use client"

import { useEffect } from "react"

import {
  StringtaleProviderBase,
  StringtaleProviderProps,
  useStringtaleContext,
} from "@stringtale/react"

export const StringtaleProvider = (props: StringtaleProviderProps) => {
  return (
    <StringtaleProviderBase
      {...props}
      onChange={async () => {
        // We do nothing here
      }}
    >
      <DataLoader />
      {props.children}
    </StringtaleProviderBase>
  )
}

const DataLoader = () => {
  const { setData } = useStringtaleContext()
  useEffect(() => {
    setData([])
  }, [setData])
  return null
}

export default StringtaleProvider
